const fromSalesOrderRequest = require('./fromSalesOrderRequest');
const fromSalesOrderResponse = require('./fromSalesOrderResponse');
const toSalesOrderRequest = require('./toSalesOrderRequest');
const toSalesOrderResponse = require('./toSalesOrderResponse');
const toSubscriptionUpdateRequest = require('./toSubscriptionUpdateRequest');

module.exports = {
    fromSalesOrderRequest,
    fromSalesOrderResponse,
    toSalesOrderRequest,
    toSalesOrderResponse,
    toSubscriptionUpdateRequest
};
